import type { HistoryEntry } from '../api/onboarding-types'
import { STATUS_LABEL } from '../utils/onboarding-meta'
import type { OnboardingStatus } from '../api/onboarding-types'

const EVENT_LABEL: Record<string, string> = {
  created: 'Created',
  edited: 'Edited',
  document_uploaded: 'Document uploaded',
  document_withdrawn: 'Document withdrawn',
  hs_code_suggested: 'HS code suggestions looked up',
}

/** Older entries say "Commercial sign-off"; the step is called Operations sign-off now. */
function noteText(note: unknown): string | null {
  if (typeof note !== 'string' || !note) return null
  return note === 'Commercial sign-off' ? 'Operations sign-off' : note
}

function describe(e: HistoryEntry): string {
  if (e.event?.startsWith('push:')) return `Odoo: ${e.event.slice(5).replace('_', ' ')} done`
  if (e.event && e.event !== 'created') {
    const what = EVENT_LABEL[e.event] ?? e.event
    const fields = Array.isArray(e.fields) ? ` (${(e.fields as string[]).join(', ')})` : ''
    const doc = typeof e.doc_type === 'string' ? ` (${e.doc_type})` : ''
    return what + fields + doc
  }
  if (e.to) return `${e.event === 'created' ? 'Created as ' : 'Moved to '}${STATUS_LABEL[e.to as OnboardingStatus] ?? e.to}`
  return e.event ?? ''
}

export function OnboardingHistory({ entries }: { entries: HistoryEntry[] }) {
  return (
    <ol className="flex flex-col gap-2">
      {[...entries].reverse().map((e, i) => (
        <li key={i} className="border-l-2 border-border-subtle pl-3 text-sm">
          <div>{describe(e)}</div>
          {noteText(e.note) ? <div className="text-secondary">{noteText(e.note)}</div> : null}
          <div className="text-xs text-tertiary">
            {new Date(e.at).toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' })}
            {' · '}
            {e.actor}
          </div>
        </li>
      ))}
    </ol>
  )
}
